import React from 'react';
import { Button } from '@welbe/design-system';

import { ButtonUploadXLSX } from 'Views/Campaigns/components/Campaign/Tabs/Results/components/ButtonUploadXSX/ButtonUploadXSLS';

import { Container } from './Footer.styles';

interface FooterProps {
	onToggleDetails: () => void;
}

export const Footer = ({ onToggleDetails }: FooterProps) => {
	return (
		<Container>
			<Button width="240px" variant="outline" onClick={onToggleDetails}>
				Regresar
			</Button>
			<ButtonUploadXLSX />
		</Container>
	);
};
